import { render, staticRenderFns } from "./SubjectsHeaders.vue?vue&type=template&id=7f7f5712&scoped=true"
import script from "./SubjectsHeaders.vue?vue&type=script&lang=js"
export * from "./SubjectsHeaders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7f5712",
  null
  
)

export default component.exports